import "./Index.css";

const Login = () => {
  return (
    <div className="auth-container">
      <div className="header">
        <h1>Greška - ova stranica nikada ne bi trebalo da se otvori</h1>
      </div>
    </div>
  );
};

export default Login;
